// @flow

import { type OpenedIncomingPayment } from './types';
import { type CheckoutPaymentOptions } from './checkout-payment-options';

function getCheckoutPaymentOptions(incomingPayment: OpenedIncomingPayment): ?CheckoutPaymentOptions {
  return incomingPayment.checkout_payment_options;
}

export function getSafeCheckoutPaymentOptions(incomingPayment: OpenedIncomingPayment): CheckoutPaymentOptions {
  const checkoutPaymentOptions = getCheckoutPaymentOptions(incomingPayment);

  if (!checkoutPaymentOptions) {
    throw new Error('checkoutPaymentOptions is not defined');
  }

  return checkoutPaymentOptions;
}
